import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { DEFAULT_WORKBENCH_THEME, WorkbenchTheme } from '../../shared/themes';
import { CounterVariant } from './counter-variant';

@Component({
  tag: 'wb-counter',
  styleUrl: 'counter.scss',
  shadow: true,
})
export class CounterComponent implements ComponentInterface {
  /** the number displayed in the counter */
  @Prop({ reflect: true })
  public value: number = 0;

  /** the maximum value allowed. when exceeded, the component will display the max number and a `+`. i.e.`99+`*/
  @Prop({ reflect: true })
  public max: number = 99;

  /** the colour scheme */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme = DEFAULT_WORKBENCH_THEME;

  /** the colour variant */
  @Prop({ reflect: true })
  public variant: CounterVariant = 'primary';

  private TagNames = transformTagNames(this, 'wb-counter', ['wb-text']);

  private evaluate(value: number): string {
    const valueAsInt: number = Number.parseInt(String(value));
    const maxAsInt: number = Number.parseInt(String(this.max));

    if (isNaN(valueAsInt)) {
      return ' ';
    }

    return valueAsInt <= maxAsInt ? String(valueAsInt) : maxAsInt + '+';
  }

  public render(): JSX.Element {
    const { WbText } = this.TagNames;
    const label = this.evaluate(this.value);

    return (
      <Host class="wb-counter">
        <div class={{ 'has-padding': label.length > 1 }}>
          <WbText size="s" strong static>
            {label}
          </WbText>
        </div>
      </Host>
    );
  }
}
